import { buildUiPalettes } from "../ui/utils/uiPalette";
import { colorMap } from "./constants";
import type { UseThemeType } from "./types";

const primaryColour = "#14435B";
const secondaryColour = "#1b678e";

export const defaultTheme: UseThemeType = {
  sizes: {
    isMobile: false,
    isTablet: false,
    isComputer: true,
    isLargeComputer: false,
    width: 1024,
  },
  primaryColour,
  secondaryColour,
  colors: buildUiPalettes({ colorMap, primaryColour, secondaryColour }),
  fontFamily: {
    h1: "Inter",
    h2: "Inter",
    h3: "Inter",
    h4: "Inter",
    h5: "Inter",
    body: "Inter",
  },
};
